export default [
  {
    path: 'shiftManage',
    component: () => import(/* webpackChunkName: "shift-manage" */ '@/pages/scheduling/ShiftManage'),
    meta: { title: '班次管理', cate: '排班考勤' }
  },
  {
    path: 'attendanceGroup',
    component: () => import(/* webpackChunkName: "attendance-group" */ '@/pages/scheduling/AttendanceGroup'),
    meta: { title: '考勤组管理', cate: '排班考勤' }
  },
  {
    path: 'scheduleManage',
    component: () => import(/* webpackChunkName: "schedule-manage" */ '@/pages/scheduling/ScheduleManage'),
    meta: { title: '排班管理', cate: '排班考勤' }
  }
]
